import React, { useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import SharedForm from "../../../../components/ui/Form";
import {
    ALERT_TYPE,
    ALIGN,
    POSITIONS,
    YES_NO_INVERSE,
    AG_RECRUITMENT_MEMBER_STATUS,
} from '../../../../constants';
import { AlertContext } from "../../../../context/AlertContext";
import { updateAdvisoryGroupRosterMemberData } from "../../../../ducks/advisoryGroup";
import messages from "../../../../utils/helper/messages";
import { memberRetirementReasons, optionValues } from "../../../../utils/utils";
import withAuth from "../../../../components/hoc/withAuth";

const EditRosterDetailsModal = ({ show, data, onCancel }) => {
    const dispatch = useDispatch();
    const { showAlert } = useContext(AlertContext);

    const currentUser = useSelector((state) => state.user.currentUser);
    const retirementReasons = useSelector((state) => state.advisoryGroup.retirementReasons);

    const [isLoading, setIsLoading] = useState(false);
    const [memberDetails, setMemberDetails] = useState(null);

    const arr = [
        {
            key: 'retirementReason',
            labelName: 'Retirement Reason',
            placeholderName: 'Retirement Reason',
            type: 'options',
            optionValues: optionValues(memberRetirementReasons(retirementReasons), true),
            required: true,
            conditional: true,
            dependsOn: 'memberRetiring',
            dependsValue: [YES_NO_INVERSE.Yes]
        },
    ];

    const onHideCallback = () => {
        setMemberDetails(null);
        onCancel();
    }

    const handleSuccess = () => {
        setIsLoading(false);
        showAlert(messages.success.retireMember, ALERT_TYPE.SUCCESS);
        onCancel();
    }

    const handleError = (error) => {
        setIsLoading(false);
        showAlert(`${messages.error.prefix} ${error}.`, ALERT_TYPE.ERROR);
    }

    const handleMemberDetailsChange = (update) => {
        setMemberDetails((details) => ({ ...details, ...update }));
    }

    const handleInputChange = (name, value) => {
        handleMemberDetailsChange({ [name]: value });
    };

    const handleSubmit = async (formData) => {
        if (!formData) return;

        setIsLoading(true);
        const submitData = {
            id: data?.id,
            lastUsertoUpdateRecord: currentUser?.id,
            memberRetireDate: new Date(),
            retirementReason: formData.retirementReason,
            memberStatus: AG_RECRUITMENT_MEMBER_STATUS.Retired
        };

        dispatch(updateAdvisoryGroupRosterMemberData(submitData, handleSuccess, handleError));
        onCancel();
        setIsLoading(false);
    }

    return (
        <Modal
            show={show}
            fullscreen={false}
            backdrop="static"
            onHide={onHideCallback}
            size="md">
            <Modal.Header closeButton>
                <Modal.Title>AG Member </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="px-xl-2 py-xl-2">
                    <SharedForm
                        cols={12}
                        array={arr}
                        modelObj={memberDetails}
                        loading={isLoading}
                        onInputChanged={handleInputChange}
                        onSubmit={handleSubmit}
                        onCancel={onHideCallback}
                        actionBarPosition={POSITIONS.TOP}
                        actionBarAlign={ALIGN.RIGHT}
                        submitButtonText="Save"
                    />
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default withAuth(EditRosterDetailsModal);
